import { useNavigate } from "react-router-dom";
import { FiUser, FiUsers } from "react-icons/fi";
import "./page.css"

const SelectLogin = () => {
  const navigate = useNavigate();

  return (
    <div className="login-wrapper">
      <div className="login-card">
        <img
          src="/irc-logo.png"
          alt="Logo"
          className="login-logo"
        />

        <h2 className="login-title">Login As</h2>
        <p className="login-subtitle">
          Select how you want to access the system
        </p>

        <button
          className="login-btn primary"
          onClick={() => navigate("/admin-login")}
        >
          <FiUser size={18} />
          <span>Super Admin / Admin</span>
        </button>

        <button
          className="login-btn secondary"
          onClick={() => navigate("/app-user-login")}
        >
          <FiUsers size={18} />
          <span>QC / Operations / Accounts</span>
        </button>
      </div>
    </div>
  );
};

export default SelectLogin;
